import { __awaiter, __generator } from "tslib";
import { logger } from '../logger';
import { version } from './constants';
import { load6Sense } from './sources/6sense';
import { loadAlbacross } from './sources/albacross';
import { loadClearbitV1 } from './sources/clearbitV1';
import { loadClearbitV2 } from './sources/clearbitV2';
import { loadDealfront } from './sources/dealfront';
import { loadDemandbase } from './sources/demandbase';
import { loadRollworks } from './sources/rollworks';
import { loadSnitcher } from './sources/snitcher';
import { loadTriblio } from './sources/triblio';
import { loadZoomInfo } from './sources/zoominfo';
import { getMatchingSources, verifyOptions } from './utils';
var SOURCES = [
    {
        name: '6sense',
        load: [load6Sense],
    },
    {
        name: 'albacross',
        load: [loadAlbacross],
    },
    {
        name: 'clearbit',
        load: [loadClearbitV1],
    },
    {
        name: 'dealfront',
        load: [loadDealfront],
    },
    {
        name: 'demandbase',
        load: [loadDemandbase],
    },
    {
        name: 'rollworks',
        load: [loadRollworks],
    },
    {
        name: 'snitcher',
        load: [loadSnitcher],
    },
    {
        name: 'triblio',
        load: [loadTriblio],
    },
    {
        name: 'zoomInfo',
        load: [loadZoomInfo],
    },
    {
        name: 'autoGroup',
        load: [
            load6Sense,
            loadAlbacross,
            loadDealfront,
            loadDemandbase,
            loadRollworks,
            loadTriblio,
            loadZoomInfo,
            loadClearbitV2,
        ],
    },
];
export var ddIntentSources = function (options) {
    return {
        name: 'IntentSources',
        type: 'utility',
        version: version,
        isLoaded: function () { return true; },
        load: function (ctx, analytics) { return __awaiter(void 0, void 0, void 0, function () {
            var intentSourcesOptions, matchingSources, promises, _i, matchingSources_1, source, sourceOptions, _a, _b, load;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        intentSourcesOptions = options.intentSources || {};
                        if (!verifyOptions(intentSourcesOptions)) {
                            return [2 /*return*/];
                        }
                        logger.debug('Enabling intent sources using options', {
                            intentSourcesOptions: intentSourcesOptions,
                        });
                        matchingSources = getMatchingSources(SOURCES, intentSourcesOptions);
                        promises = [];
                        for (_i = 0, matchingSources_1 = matchingSources; _i < matchingSources_1.length; _i++) {
                            source = matchingSources_1[_i];
                            sourceOptions = intentSourcesOptions[source.name];
                            if (typeof sourceOptions !== 'object') {
                                sourceOptions = {};
                            }
                            for (_a = 0, _b = source.load; _a < _b.length; _a++) {
                                load = _b[_a];
                                promises.push(load(analytics, sourceOptions));
                            }
                        }
                        return [4 /*yield*/, Promise.all(promises)];
                    case 1:
                        _c.sent();
                        return [2 /*return*/, ctx];
                }
            });
        }); },
    };
};
//# sourceMappingURL=index.js.map